import { createStore } from 'vuex';
import { merge } from 'lodash';
import storeConfig from './storeConfig';
import SdkStoreConfig from '@nsftx/games-sdk-js/src/store/storeConfig';

export default createStore(merge(storeConfig, SdkStoreConfig));
